// extracted by mini-css-extract-plugin
export default {"TallyForm":"InterestForm_TallyForm__EZxj9"};